export type TableEndOfListProps = {
  /** Everything is loaded AND the operator lazy-loaded at least once —
   *  short single-page lists stay clean. */
  isEndReached: boolean
  /** Loaded row count, for the line. */
  rowCount: number
  /** Noun for the line — same label the toolbar count uses. */
  countLabel: string
}

/**
 * The infinite-scroll footer, rendered under the table at the BOTTOM of the
 * scroll container where the operator is looking after a lazy load. Answers
 * the "is more coming?" question once everything landed; while a page is
 * still on its way the body's placeholder rows answer it in place.
 */
function TableEndOfList(props: TableEndOfListProps) {
  const { isEndReached, rowCount, countLabel } = props

  if (!isEndReached) return null
  return (
    <div className="ui-table-end-of-list">
      {`All ${rowCount} ${countLabel} loaded`}
    </div>
  )
}

export default TableEndOfList
